/**
 * Fime – Leadership Team: "Read more" / "Read less" toggle
 * (3-line clamp), independent per card.
 */

const leadershipReadMoreBtns = document.querySelectorAll('.leadership-read-more');

leadershipReadMoreBtns.forEach(function (btn) {
	btn.addEventListener('click', function () {
		const card = btn.closest('.leadership-info');
		const wrapper = card.querySelector('.leadership-desc-wrapper');
		const isExpanded = wrapper.classList.contains('is-expanded');

		wrapper.classList.toggle('is-expanded', !isExpanded);
		btn.classList.toggle('is-open', !isExpanded);

		const label = btn.querySelector('span');
		if (label) label.textContent = isExpanded ? 'Read more' : 'Read less';
	});
});
